import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {FilterDrawer} from '../../../entity-list/filters/filter-drawer';

import {drawerFields} from './consts';

type Props = {
    activeFilters: FilterObject[];
    isFilterDrawerOpen: boolean;
    onUpdateFilters: (arg1: FilterObject) => void;
};

export function ProspectorFilterDrawer(props: Props) {
    return (
        <FilterDrawer
            hasTopBorder={false}
            shouldShowPreappliedFiltersAtTop={false}
            allowNegation={false}
            hasSearch={false}
            activeFilters={props.activeFilters}
            entityType='mcfxcompanies'
            isOpen={props.isFilterDrawerOpen}
            fields={drawerFields}
            onSubmitFilter={(filterObj: FilterObject) => {
                props.onUpdateFilters(filterObj);
            }}
            onRemoveFilter={(filterObj: string) => {
                props.onUpdateFilters({[filterObj]: null});
            }}
        />
    );
}
